import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EnrollmentEffects } from './store/effects/enrollment.effects';
import { enrollmentReducer } from './store/reducers/enrollment.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('enrollment', enrollmentReducer),
    EffectsModule.forFeature([EnrollmentEffects]),
  ],
})
export class EnrollmentModule {}
